export function getPermissionsStorageKey(
  companyId: string,
  userId: string,
): string {
  return `abrafi_perms:${companyId}:${userId}`;
}

export function getCachedPermissions(
  companyId: string | null | undefined,
  userId: string | null | undefined,
): string[] {
  if (!companyId || !userId) return [];
  const key = getPermissionsStorageKey(companyId, userId);
  const raw = localStorage.getItem(key);
  if (!raw) return [];
  try {
    return JSON.parse(raw) as string[];
  } catch {
    return [];
  }
}
